import styled from 'styled-components';
import { ThemeData } from '../quantData';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

interface Props {
  selectedIndexes: number[];
  isOpen: boolean;
  onClose: () => void;
}

function ThemeSelectModal({ selectedIndexes, isOpen, onClose }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tempIndexes, setTempIndexes] = useState<number[]>(selectedIndexes);

  const toggleSelect = (index: number) => {
    const item = ThemeData[index];

    setTempIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  const resetSelection = () => {
    setTempIndexes([]);
  };

  const handleConfirm = () => {
    const newParams = new URLSearchParams(searchParams);
    if (tempIndexes.length > 0) {
      newParams.set('indexes', tempIndexes.join(','));
    } else {
      newParams.delete('indexes');
    }
    setSearchParams(newParams);
    onClose();
  };

  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <TitleBox>
          <Spacer />
          <Title>테마주 선택하기</Title>
          <img
            src="/assets/images/close/close-dark-gray.svg"
            alt="닫기"
            width={24}
            onClick={onClose}
          />
        </TitleBox>
        <ItemBox>
          {ThemeData.map((item, index) => {
            const selected = tempIndexes.includes(index);

            return (
              <Item
                key={index}
                selected={selected}
                onClick={() => toggleSelect(index)}
              >
                <ItemTitleWrapper>
                  <ItemTitle>{item.name}</ItemTitle>
                  <img
                    src={
                      selected
                        ? '/assets/images/check/circle-checked-blue.svg'
                        : '/assets/images/check/circle-checked-gray.svg'
                    }
                    alt="선택 여부"
                    width={20}
                    height={20}
                  />
                </ItemTitleWrapper>
                <ItemDescription>{item.description}</ItemDescription>
              </Item>
            );
          })}
        </ItemBox>
        <ButtonBox>
          <ResetButton onClick={resetSelection}>초기화</ResetButton>
          <ConfirmButton onClick={handleConfirm}>알고리즘 저장</ConfirmButton>
        </ButtonBox>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default ThemeSelectModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px -4px 15px 0px #00000040;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
`;
const Spacer = styled.div`
  width: 24px;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const CloseButton = styled.button`
  cursor: pointer;
`;

const ItemBox = styled.div`
  width: 100%;
  height: 440px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`;

const Item = styled.div<{ selected: boolean; disabled?: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 12px;
  padding: 14px;
  gap: 8px;
  border: 1px solid ${(props) => (props.selected ? '#008AFF' : '#E5E8EA')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

const ItemTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ItemTitle = styled.div<{ disabled?: boolean }>`
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${({ disabled }) => (disabled ? '#888888' : '#222222')};
`;

const ItemDescription = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  border-top-width: 1px;
  padding-top: 16px;
  padding-right: 16px;
  padding-bottom: 40px;
  padding-left: 16px;
`;

const ResetButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 0 0 auto;
  border-radius: 8px;
  padding: 12px 28px;
  background-color: #70737c14;
  border: none;
  cursor: pointer;

  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
`;

const ConfirmButton = styled.button`
  border-radius: 8px;
  padding: 14px 28px;
  flex: 1;
  background-color: #008aff;
  border: none;
  color: #ffffff;
  cursor: pointer;

  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
`;
